import {
  faPresentationScreen,
  faObjectUngroup,
} from '@fortawesome/pro-solid-svg-icons';
import {
  faMeUiTemplates,
  faMeNotionTemplates,
} from '@/assets/icons/me-font-icons-regular.js';
import {
  faMePrompt,
} from '@motionelements/assets/src/js/me-font/icons/me-font-icons-solid.js';

export default {
  name: 'NewMediaTypesMixin',
  data() {
    return {
      mediaTypes: {
        graphic: {
          heading: this.$t('contributor.submission.media_type.graphic'),
          headingHtml: this.$t(this.$wbr('contributor.submission.media_type.graphic')),
          desc: this.$t(this.$wbr('contributor.submission.media_type.graphic_subheading')),
          icon: faObjectUngroup,
        },
        notion: {
          heading: this.$t('contributor.submission.media_type.notion'),
          headingHtml: this.$t(this.$wbr('contributor.submission.media_type.notion')),
          desc: this.$t(this.$wbr('contributor.submission.media_type.notion_subheading')),
          icon: faMeNotionTemplates,
        },
        ui: {
          heading: this.$t('contributor.submission.media_type.ui'),
          headingHtml: this.$t(this.$wbr('contributor.submission.media_type.ui')),
          desc: this.$t(this.$wbr('contributor.submission.media_type.ui_subheading')),
          icon: faMeUiTemplates,
        },
        presentation: {
          heading: this.$t('contributor.submission.media_type.presentation'),
          headingHtml: this.$t(this.$wbr('contributor.submission.media_type.presentation')),
          desc: this.$t(this.$wbr('contributor.submission.media_type.presentation_subheading')),
          icon: faPresentationScreen,
        },
        image_prompt: {
          heading: this.$term('mediaType', 'image_prompt').plural().html(),
          headingHtml: this.$term('mediaType', 'image_prompt').wbr().plural().html(),
          desc: this.$t(this.$wbr('contributor.submission.media_type.prompt_subheading')),
          icon: faMePrompt,
          bgImage: 'https://static.moele.me/img/channels2022/submission/prompt.010324.svg?auto=format&w=2857',
          bgImageDark: 'https://static.moele.me/img/channels2022/submission/prompt-dark.010324.svg?auto=format&w=2857',
          bgClass: 'image-prompt-gradient-bg',
          faqType: 'cfs_image_prompt',
        },
      },
    };
  },
};
